<template>
  <div class="loginPage">
    <v-row dense no-gutters class="auth-row">
      <v-col cols="12" sm="12" md="6" class="custom-height">
        <div class="auth-light-version mt-6">
          <div class="logo mb-12">
            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
          </div>
          <h3 class="mb-6">Create New Account</h3>
          <v-form class="deposit-form password-field">
            <div class="form-details pt-0 pb-10">
              <div v-if="registerInfo.otpSent === 0" key="register-step">
                <fieldset v-if="registerInfo.owner_type == 2">
                  <legend>Company Name</legend>
                  <v-text-field placeholder="Enter Company Name" type="text" v-model="registerInfo.fname" single-line
                    solo hide-details class="custom-select" />
                </fieldset>

                <template v-else>
                  <fieldset>
                    <legend>First Name</legend>
                    <v-text-field placeholder="Write First Name" type="text" v-model="registerInfo.fname" single-line
                      solo hide-details class="custom-select" />
                  </fieldset>

                  <fieldset>
                    <legend>Last Name</legend>
                    <v-text-field placeholder="Write Last Name" type="text" v-model="registerInfo.lname" single-line
                      solo hide-details class="custom-select" />
                  </fieldset>
                </template>

                <fieldset>
                  <legend>Select Country</legend>
                  <v-select :items="countries" item-text="name" item-value="id" placeholder="Select Country"
                    v-model="registerInfo.country" solo hide-details class="custom-select reg-page" />
                </fieldset>

                <fieldset>
                  <legend>Email</legend>
                  <v-text-field placeholder="Write your email address" type="email" v-model="registerInfo.email"
                    single-line solo hide-details class="custom-select" />
                </fieldset>

                <div v-if="inv_referred_by">
                  <fieldset>
                    <legend>Copy Ratio
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" style="cursor: pointer;"
                            class="tooltip-custom">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>Trades will be copied according to the selected ratio.</span>
                      </v-tooltip>
                    </legend>
                    <v-select ref="accountTypeSelect" v-model="registerInfo.multiply_by" solo :items="copyTradeAsRatio"
                      item-value="id" item-text="ratio_type_display" append-icon="mdi-chevron-down"
                      label="Select Copy Ratio" class="custom-select" single-line hide-details="auto" />
                  </fieldset>
                </div>

                <fieldset>
                  <legend>Password</legend>
                  <v-text-field placeholder="Write Password Here" :type="passwordVisible ? 'text' : 'password'"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="passwordVisible = !passwordVisible" v-model="registerInfo.password" single-line solo
                    hide-details counter class="custom-select" />

                  <div v-if="passwordField" class="mt-4">
                    <span v-for="(condition, index) in passwordConditions" :key="index" class="condition-items">
                      <v-icon small :class="condition.met ? 'text--green' : 'text--ash'">mdi-check</v-icon>
                      {{ condition.text }}
                    </span>
                  </div>
                </fieldset>

                <fieldset class="margin-custom">
                  <legend>Confirm Password</legend>
                  <v-text-field placeholder="Write Password Again" :type="confirmPasswordVisible ? 'text' : 'password'"
                    :append-icon="confirmPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="confirmPasswordVisible = !confirmPasswordVisible"
                    v-model="registerInfo.confirmPassword" single-line solo hide-details counter
                    class="custom-select" />
                </fieldset>

                <div id="recaptcha-container" ref="recaptchaContainer"></div>
                <div v-if="recaptchaError" class="error-message mt-2">
                  {{ recaptchaError }}
                </div>

                <div class="mb-5 mt-5 agree">
                  <input type="checkbox" v-model="checkbox" class="custom-checkbox">
                  I Agree With Your<a target="_blank" :href="termsAndConditionLink"> Terms & Conditions</a>
                </div>

                <v-btn class="ma-0 text-capitalize btn-account" color="#039de9" tile block elevation="0"
                  @click.prevent="handleSendOTP" :loading="loading"
                  :disabled="loading || !isEmailValid || !isPasswordFieldsValid || !arePasswordsMatching || !checkbox || !fnameCheck || !this.registerInfo.country || !invCheck || !isRecaptchaValid">
                  Next
                </v-btn>
              </div>

              <div v-else key="otp-step" class="pt-5">
                <fieldset>
                  <legend>OTP</legend>
                  <v-text-field placeholder="Enter OTP" single-line solo hide-details :value="registerInfo.otp"
                    @input="(value) => REGISTER_INFO({ field: 'otp', value })" class="custom-select"></v-text-field>
                </fieldset>

                <div class="px-0 pb-0">
                  <v-row no-gutters>
                    <v-col cols="4">
                      <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                        @click.prevent="previous">
                        Previous
                      </v-btn>
                    </v-col>
                    <v-col cols="8" class="pl-2">
                      <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                        @click.prevent="handleRegister" :loading="loadingCreate"
                        :disabled="!allConditionsMet || loadingCreate">
                        Create Account
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="another-link mt-6">
                <p>
                  Already have an account?
                  <router-link to="/">Log in</router-link>
                </p>
              </div>
            </div>
          </v-form>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="image-col">
        <div class="image-content">
          <h3 class="mb-2">High Risk Investment Warning:</h3>
          <p>
            Trading Leveraged Products such
            as Forex and Derivatives may not be suitable for all investors as they carry a
            high degree of risk to your capital. Please ensure that you fully understand
            the risks involved, taking into account your investments objectives and level
            of experience, before trading, and if necessary, seek independent advice.
          </p>
          <social-icons :info="genInfo"></social-icons>
        </div>
        <div class="image-container">
          <v-img src="@/assets/auth.png" class="zoom-animate-full image-full"></v-img>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import SocialIcons from "./SocialIcons.vue";

export default {
  components: { LanguageMenu, SocialIcons },

  data() {
    return {
      genInfo: {},
      checkbox: false,
      loading: false,
      loadingCreate: false,
      passwordVisible: false,
      confirmPasswordVisible: false,
      inv_referred_by: null,
      recaptchaToken: null,
      recaptchaError: null,
      recaptchaLoaded: false,
      recaptchaWidgetId: null,
      copyTradeAsRatio: [
        { id: 0, ratio_type_display: "Proportional to equity" },
        { id: 1, ratio_type_display: "1X" },
        { id: 2, ratio_type_display: "2X" },
        { id: 3, ratio_type_display: "3X" },
        { id: 4, ratio_type_display: "4X" },
        { id: 5, ratio_type_display: "5X" },
      ],
      selectedRatio: 0,
      e1: 1,
      fields: [
        {
          name: "fname",
          legend: "First Name",
          placeholder: "John",
          type: "text",
        },
        {
          name: "lname",
          legend: "Last Name",
          placeholder: "Doe",
          type: "text",
        },
        {
          name: "country",
          legend: "Select Country",
          placeholder: "Select Country",
          type: "select",
        },
        {
          name: "email",
          legend: "Email",
          placeholder: "Write your email address",
          type: "email",
        },
        {
          name: "password",
          legend: "Password",
          placeholder: "Enter Here",
          type: "password",
          show: false,
          counter: true,
        },
        {
          name: "confirmPassword",
          legend: "Confirm Password",
          placeholder: "Write Password Again",
          type: "password",
          show: false,
          counter: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("register", ["registerInfo", "registrationError"]),
    ...mapGetters("register", ["isOtpSent", "isOtpVerified", "isRegistered"]),
    ...mapState("publicinfo", ["info", "countries", "termsAndConditionLink"]),

    isEmailValid() {
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailRegex.test(this.registerInfo.email);
    },

    isPasswordFieldsValid() {
      return (
        this.registerInfo.password &&
        this.registerInfo.confirmPassword &&
        this.registerInfo.password.length > 0 &&
        this.registerInfo.confirmPassword.length > 0 &&
        this.passwordConditions.every((condition) => condition.met)
      );
    },

    arePasswordsMatching() {
      return (
        this.registerInfo.password === this.registerInfo.confirmPassword &&
        this.registerInfo.password !== "" &&
        this.registerInfo.confirmPassword !== ""
      );
    },

    fnameCheck() {
      return (
        this.registerInfo.fname && this.registerInfo.fname.trim().length > 0
      );
    },

    invCheck() {
      if (this.inv_referred_by) {
        return (
          this.registerInfo.multiply_by !== null &&
          this.registerInfo.multiply_by !== ""
        );
      }
      return true;
    },

    isRecaptchaValid() {
      return this.recaptchaToken !== null && this.recaptchaToken !== "";
    },

    passwordConditions() {
      const password = this.registerInfo.password || "";
      return [
        { met: password.length >= 8, text: "8 Characters" },
        { met: /[a-z]/.test(password), text: "1 Lowercase" },
        { met: /[A-Z]/.test(password), text: "1 Uppercase" },
        { met: /\d/.test(password), text: "1 Digit" },
        { met: /[@$!%*?&]/.test(password), text: "1 Special Character" },
      ];
    },

    allConditionsMet() {
      return (
        this.isPasswordFieldsValid &&
        this.arePasswordsMatching &&
        this.registerInfo.otp &&
        this.registerInfo.otp.length > 0
      );
    },

    passwordField() {
      return this.fields.find((field) => field.name === "password");
    },

    logoSrc() {
      return this.$vuetify.theme.light
        ? this.info?.logo_url
        : this.info?.logo_url_dark;
    },

    logoWidth() {
      return this.info?.logo_width || "100%";
    },

    logoHeight() {
      return this.info?.logo_height || "100%";
    },
  },

  methods: {
    ...mapMutations("register", {
      REGISTER_INFO: "SET_REGISTER_INFO",
    }),

    ...mapActions("register", [
      "sendOTP",
      "previousStep",
      "verifyOTP",
      "register",
      "initializeReferral",
    ]),

    ...mapActions("publicinfo", [
      PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO,
      PUBLIC_LOGIN__ACTIONS.TERMSANDCONDITIONLINK,
      PUBLIC_LOGIN__ACTIONS.COUNTRIES,
    ]),

    loadRecaptchaScript() {
      return new Promise((resolve, reject) => {
        if (window.grecaptcha && window.grecaptcha.render) {
          this.recaptchaLoaded = true;
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
        script.async = true;
        script.defer = true;

        window.onRecaptchaLoad = () => {
          this.recaptchaLoaded = true;
          resolve();
        };

        script.onerror = () => {
          reject(new Error("Failed to load reCAPTCHA script"));
        };

        document.head.appendChild(script);
      });
    },

    renderRecaptcha() {
      if (!this.recaptchaLoaded || !window.grecaptcha) {
        console.error("reCAPTCHA not loaded yet");
        return;
      }

      try {
        if (this.$refs.recaptchaContainer && this.recaptchaWidgetId === null) {
          this.recaptchaWidgetId = window.grecaptcha.render(
            this.$refs.recaptchaContainer,
            {
              sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
              callback: this.onRecaptchaSuccess,
              "expired-callback": this.onRecaptchaExpired,
              "error-callback": this.onRecaptchaError,
              theme: "light",
              size: "normal",
            }
          );
        }
      } catch (error) {
        console.error("Error rendering reCAPTCHA:", error);
        this.recaptchaError =
          "Failed to load reCAPTCHA. Please refresh the page.";
      }
    },

    async rerenderRecaptcha() {
      this.recaptchaWidgetId = null;
      await this.$nextTick();
      this.renderRecaptcha();
    },

    onRecaptchaSuccess(token) {
      this.recaptchaToken = token;
      this.recaptchaError = null;

      this.REGISTER_INFO({
        field: "recaptcha_token",
        value: token,
      });
    },

    onRecaptchaExpired() {
      this.recaptchaToken = null;
      this.recaptchaError = "reCAPTCHA expired. Please verify again.";

      this.REGISTER_INFO({
        field: "recaptcha_token",
        value: "",
      });
    },

    onRecaptchaError() {
      this.recaptchaToken = null;
      this.recaptchaError = "reCAPTCHA error. Please try again.";

      this.REGISTER_INFO({
        field: "recaptcha_token",
        value: "",
      });
    },

    resetRecaptcha() {
      if (window.grecaptcha && this.recaptchaWidgetId !== null) {
        try {
          window.grecaptcha.reset(this.recaptchaWidgetId);
        } catch (error) {
          console.error("Error resetting reCAPTCHA:", error);
        }
      }

      this.recaptchaToken = null;
      this.recaptchaError = null;

      this.REGISTER_INFO({
        field: "recaptcha_token",
        value: "",
      });
    },

    destroyRecaptcha() {
      try {
        if (window.grecaptcha && this.recaptchaWidgetId !== null) {
          window.grecaptcha.reset(this.recaptchaWidgetId);
        }
      } catch (error) {
        console.error("Error destroying reCAPTCHA:", error);
      }

      this.recaptchaWidgetId = null;
      this.recaptchaToken = null;
      this.recaptchaError = null;

      this.REGISTER_INFO({
        field: "recaptcha_token",
        value: "",
      });
    },

    async handleSendOTP() {
      if (!this.recaptchaToken) {
        this.recaptchaError = "Please complete the reCAPTCHA verification";
        return;
      }

      try {
        this.loading = true;
        this.recaptchaError = null;

        this.REGISTER_INFO({
          field: "recaptcha_token",
          value: this.recaptchaToken,
        });

        await this.sendOTP();
      } catch (error) {
        console.log(error);
        this.recaptchaError =
          error?.response?.data?.message ||
          "Registration failed. Please try again.";

        this.resetRecaptcha();
        await this.rerenderRecaptcha();
      } finally {
        this.loading = false;
      }
    },

    async previous() {
      try {
        await this.previousStep();

        this.REGISTER_INFO({ field: "recaptcha_token", value: "" });
        this.REGISTER_INFO({ field: "recaptcha_session_token", value: "" });

        this.resetRecaptcha();
        await this.rerenderRecaptcha();
      } catch (error) {
        console.log(error);
      }
    },

    async handleRegister() {
      if (!this.allConditionsMet) return;

      try {
        this.loadingCreate = true;

        await this.verifyOTP();

        if (this.isOtpVerified) {
          await this.register();

          if (window.fbq) {
            fbq("track", "CompleteRegistration", {
              fn: this.registerInfo.fname,
              ln: this.registerInfo.lname,
            });
          }

          this.$router.push("/login");
        }
      } catch (error) {
        console.error("Error during registration:", error);
      } finally {
        this.loadingCreate = false;
      }
    },

  },

  async mounted() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    await this[PUBLIC_LOGIN__ACTIONS.TERMSANDCONDITIONLINK]();
    await this[PUBLIC_LOGIN__ACTIONS.COUNTRIES]();
    this.initializeReferral();

    this.genInfo = this.info || {};

    try {
      await this.loadRecaptchaScript();
      this.$nextTick(() => {
        this.renderRecaptcha();
      });
    } catch (error) {
      console.error("Failed to load reCAPTCHA:", error);
      this.recaptchaError =
        "Failed to load reCAPTCHA. Please refresh the page.";
    }

    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      fbq("init", "1601047264632923");
    }

    fbq("track", "PageView");
  },

  created() {
    let urlParams = new URLSearchParams(window.location.search);
    this.inv_referred_by = urlParams.get("inv_referred_by");
  },

  watch: {
    "registerInfo.otpSent"(newVal) {
      if (newVal === 1) {
        this.destroyRecaptcha();
      }

      if (newVal === 0 && this.recaptchaLoaded) {
        this.$nextTick(() => {
          this.rerenderRecaptcha();
        });
      }
    },
  },

  beforeDestroy() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha) {
      try {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      } catch (error) {
        console.error("Error cleaning up reCAPTCHA:", error);
      }
    }
  },
};
</script>

<style>
.reg-page .v-list .v-list-item--active {
  background-color: #F1F7FB !important;
}

.reg-page .v-list .v-select-list {
  background-color: #1B1D81 !important;
}

.tooltip-custom {
  position: relative;
  top: 0;
  left: 3px;
  font-size: 15px;
  color: #ffffffa1;
}

.margin-custom {
  margin-top: 75px;
}

.condition-items {
  overflow: visible;
  font-size: 13px;
  align-items: center;
  color: #708aa7;
}

.agree {
  color: #131c29;
  font-size: 13px;
}

.agree a {
  color: #039DE9;
}

.custom-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  outline: none;
  cursor: pointer;
  border: 1px solid #3f546b;
  border-radius: 2px;
  background: #ffffff00;
  transition: background 0.3s, border-color 0.3s;
  margin-right: 8px;
  position: relative;
  top: 2px;
}

.custom-checkbox:checked {
  background: #131c29;
  border-color: #039DE9;
}

.custom-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: -9px;
  left: 2px;
  font-size: 20px;
}

.custom-checkbox:hover {
  border-color: #039DE9 !important;
}

.custom-checkbox {
  border: 1px solid #039DE9;
}

.custom-checkbox:checked {
  background: #ffffff00;
  border-color: #039DE9;
}

.custom-checkbox:checked::after {
  color: #039DE9;
}

.custom-checkbox:hover {
  border-color: #039DE9;
}

.v-select-list {
  background: #f1f7fb;
}

/* reCAPTCHA Styles */
#recaptcha-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.error-message {
  color: #f44336;
  font-size: 12px;
  text-align: center;
}
</style>